import { useMemo } from 'react';
import { axiosInstance } from 'src/api/axios';
const Redirect = () => {
  useMemo(() => {
    axiosInstance.get('/users').then((response) => {
      if ('status' in response && response.status === 200) {
        console.log(response.data);
        if (response.data.isEmailVerified || response.data.isPhoneVerified) {
          window.location.href = '/dashboard';
        } else if (!response.data.isEmailVerified || !response.data.isPhoneVerified) {
          localStorage.removeItem('token');
          localStorage.removeItem('store');
          window.location.href = '/auth/login';
        } else if (
          (response.data.isEmailVerified || response.data.isPhoneVerified) &&
          (!response.data.gender || !response.data.dob)
        ) {
          console.log(response.data);
          window.location.href = '/auth/onboarding';
        }
      }
    });
  }, []);
  return <></>;
};
export default Redirect;
